import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {authHeader} from '../utils/headers';

const API_BASE = import.meta.env.VITE_APIURL || '';

/**
 * Snapshot Pilotage d'un territoire (PIL-01 lot 1) : GET /pilotage/territoires/{slug}.
 * Réponse application/json (pas de JSON-LD, pas de @id). Le contrôleur renvoie un ETag et
 * `Cache-Control: private, no-cache` ; le snapshot est gros (~45 Mo) : on le garde 1 h en cache.
 */
export const pilotageApi = createApi({
    reducerPath: 'pilotageApi',
    baseQuery: fetchBaseQuery({
        baseUrl: API_BASE,
        prepareHeaders: (headers) => {
            const token = authHeader();
            if (typeof token === 'string' && token) {
                headers.set('authorization', token);
            }
            headers.set('Accept', 'application/json');
            return headers;
        },
    }),
    keepUnusedDataFor: 3600,
    endpoints: (builder) => ({
        getTerritoire: builder.query({
            query: (slug) => `/pilotage/territoires/${encodeURIComponent(slug)}`,
        }),
    }),
});

export const {useGetTerritoireQuery} = pilotageApi;
